if (!customElements.get('product-recommendations')) {
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			this.parent = this.closest('.product-recommendations--parent');

			if (this.classList.contains('cart-recommendations')) {
				this.cart = true;
				this.parent = this.closest('.cart-recommendations--parent');
			}
		}
		fetchProducts() {
			if (this.requestController || this.classList.contains('product-recommendations--loaded') || !this.dataset.url) return;
			const controller = new AbortController();
			this.requestController = controller;
			return fetch(this.dataset.url, { signal: controller.signal })
				.then(response => {
					if (!response.ok) throw new Error('Recommendations request failed: ' + response.status);
					return response.text();
				})
				.then(text => {
					if (!this.isConnected || this.requestController !== controller) return;
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						if (this.parent) {
							if (this.cart) {
								this.parent.classList.add('cart-recommendations--full');
							} else {
								this.parent.classList.add('product-recommendations--full');
							}
						}
						if (window.lazySizes && window.lazySizes.loader) {
							this.querySelectorAll('.lazyload').forEach((image) => {
								window.lazySizes.loader.unveil(image);
							});
						}
					}

					this.classList.add('product-recommendations--loaded');

					this.setupRelatedRail();

				})
				.catch(e => {
					if (e.name !== 'AbortError') console.error(e);
				})
				.finally(() => {
					if (this.requestController === controller) this.requestController = null;
				});
		}
		connectedCallback() {
			if (this.classList.contains('product-recommendations--loaded')) {
				this.setupRelatedRail();
				return;
			}
			if (this.observer || this.requestController) return;
			if (this.dataset.defer !== 'true' || this.cart || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
				this.fetchProducts();
				return;
			}
			// The empty custom element is display:none; observe its section's position.
			const target = this.closest('.shopify-section');
			if (!target) {
				this.fetchProducts();
				return;
			}
			this.observer = new IntersectionObserver(entries => {
				if (!entries.some(entry => entry.isIntersecting)) return;
				this.observer?.disconnect();
				this.observer = null;
				this.fetchProducts();
			}, { rootMargin: '600px 0px' });
			this.observer.observe(target);
		}

        setupRelatedRail() {
            if (this.dataset.relatedProducts !== 'true') return;
            this.relatedController?.abort();
            this.relatedResizeObserver?.disconnect();
            const track = this.querySelector('[data-related-track]');
            const cards = track?.querySelectorAll('[data-related-card]') || [];
            this.hidden = cards.length === 0;
            if (!cards.length) return;
            const controller = new AbortController();
            this.relatedController = controller;
            const signal = controller.signal;
            const previous = this.querySelector('[data-related-prev]');
            const next = this.querySelector('[data-related-next]');
            const controls = this.querySelector('[data-related-controls]');
            const hint = this.querySelector('[data-related-hint]');
            const update = () => {
                const max = Math.max(0, track.scrollWidth - track.clientWidth);
                const overflows = max > 2;
                if (controls) controls.hidden = !overflows;
                if (hint) hint.hidden = !overflows;
                if (previous) previous.disabled = track.scrollLeft <= 2;
                if (next) next.disabled = track.scrollLeft >= max - 2;
            };
            const move = (direction) => {
                const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
                track.scrollBy({ left: direction * (cards[0].getBoundingClientRect().width + gap),
                    behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            };
            previous?.addEventListener('click', () => move(-1), { signal });
            next?.addEventListener('click', () => move(1), { signal });
            track.addEventListener('scroll', update, { passive: true, signal });
            if (typeof ResizeObserver !== 'undefined') {
                this.relatedResizeObserver = new ResizeObserver(update);
                this.relatedResizeObserver.observe(track);
            } else {
                window.addEventListener('resize', update, { signal });
            }
            update();
        }

		disconnectedCallback() {
            this.relatedController?.abort();
            this.relatedResizeObserver?.disconnect();
			this.observer?.disconnect();
			this.observer = null;
			this.requestController?.abort();
			this.requestController = null;
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
